import { DEFAULT_ACTIVE_PAGE, DEFAULT_PER_PAGE_COUNT } from '@/services/constants';
import { Reducer } from 'redux';
import { AutomationsInterface, AutomationsActionTypes } from './types';

export const AutomationsInitialState: AutomationsInterface = {
    collection: [],
    singleAutomation: null,
    emailsList: [],
    statusCounts: null,
    pagination: {
        page: DEFAULT_ACTIVE_PAGE,
        perPage: DEFAULT_PER_PAGE_COUNT,
    },
    loading: false,
    automation: null,
    loadingStatusUpdate: false,
    checkedAutomations: [],
    loadingSingleAutomation: false,
    singleAutomationDailySummary: [],
    dailySummaryPagination: null,
    loadingDailySummary: false,
    contactsList: [],
    contactsListPagination: null,
    contactsTotalCount: null,
    loadingContactsList: false,
    previewTemplate: null,
    listFromAutomationLoading: false,
};

const reducer: Reducer<AutomationsInterface> = (
    state: AutomationsInterface = AutomationsInitialState,
    action
): AutomationsInterface => {
    switch (action.type) {
        case AutomationsActionTypes.GET_ALL_AUTOMATIONS_START:
            return { ...state, loading: true };
        case AutomationsActionTypes.GET_ALL_AUTOMATIONS_SUCCESS:
            return {
                ...state,
                loading: false,
                collection: action.payload.collection,
                statusCounts: action.payload.statusCounts,
                pagination: action.payload.pagination,
            };
        case AutomationsActionTypes.GET_ALL_AUTOMATIONS_ERROR:
            return { ...state, loading: false };
        case AutomationsActionTypes.UPDATE_AUTOMATION_STATUS:
            return { ...state, loadingStatusUpdate: true };
        case AutomationsActionTypes.UPDATE_AUTOMATION_STATUS_SUCCESS:
            return { ...state, loadingStatusUpdate: false, automation: action.payload.automation };
        case AutomationsActionTypes.UPDATE_AUTOMATION_STATUS_ERROR:
            return { ...state, loadingStatusUpdate: false };
        case AutomationsActionTypes.PICK_AUTOMATIONS:
            return { ...state, checkedAutomations: action.payload.checkedAutomations };
        case AutomationsActionTypes.UNPICK_AUTOMATIONS:
            return { ...state, checkedAutomations: [] };
        case AutomationsActionTypes.GET_AUTOMATION_BY_NAME_START:
            return { ...state, loadingSingleAutomation: true };
        case AutomationsActionTypes.GET_AUTOMATION_BY_NAME_SUCCESS:
            return {
                ...state,
                loadingSingleAutomation: false,
                singleAutomation: action.payload.singleAutomation,
                emailsList: action.payload.emailsList,
            };
        case AutomationsActionTypes.GET_AUTOMATION_BY_NAME_ERROR:
            return { ...state, loadingSingleAutomation: false };
        case AutomationsActionTypes.GET_AUTOMATION_DAILY_SUMMARY_START:
            return { ...state, loadingDailySummary: true };
        case AutomationsActionTypes.GET_AUTOMATION_DAILY_SUMMARY_SUCCESS:
            return {
                ...state,
                loadingDailySummary: false,
                singleAutomationDailySummary: action.payload.singleAutomationDailySummary,
                dailySummaryPagination: action.payload.dailySummaryPagination,
            };
        case AutomationsActionTypes.GET_AUTOMATION_DAILY_SUMMARY_ERROR:
            return { ...state, loadingDailySummary: false };
        case AutomationsActionTypes.GET_AUTOMATION_CONTACTS_START:
            return { ...state, loadingContactsList: true };
        case AutomationsActionTypes.GET_AUTOMATION_CONTACTS_SUCCESS:
            return {
                ...state,
                loadingContactsList: false,
                contactsList: action.payload.contactsList,
                contactsListPagination: action.payload.contactsListPagination,
                contactsTotalCount: action.payload.contactsTotalCount,
            };
        case AutomationsActionTypes.GET_AUTOMATION_CONTACTS_ERROR:
            return { ...state, loadingContactsList: false };
        case AutomationsActionTypes.LOAD_PREVIEW_TEMPLATE_SUCCESS:
        case AutomationsActionTypes.CLEAR_PREVIEW_TEMPLATE:
            return { ...state, previewTemplate: action.payload };
        case AutomationsActionTypes.CREATE_LIST_FROM_AUTOMATION:
            return { ...state, listFromAutomationLoading: true };
        case AutomationsActionTypes.CREATE_LIST_FROM_AUTOMATION_SUCCESS:
        case AutomationsActionTypes.CREATE_LIST_FROM_AUTOMATION_ERROR:
            return { ...state, listFromAutomationLoading: false };
        default:
            return state;
    }
};

export { reducer as automations };

export default reducer;
